import { CodeBook } from "@king-ict/eupisi-ui/models";
import { axiosBaseQuery } from "@king-ict/eupisi-ui/utils";
import { createApi, skipToken } from "@reduxjs/toolkit/query/react";

export interface FounderCodeBook extends CodeBook {
  institutions: CodeBook[];
}

const foundersUrlPrefix: string = "founders";

const MINIMUM_SEARCH_LENGTH = 3;

export const founderApi = createApi({
  reducerPath: "founderApi",
  baseQuery: axiosBaseQuery(),
  endpoints: (build) => ({
    searchFounders: build.query<FounderCodeBook[], string>({
      query: (searchTerm) => {
        if (searchTerm.length < MINIMUM_SEARCH_LENGTH) {
          throw skipToken;
        }

        return {
          url: `${foundersUrlPrefix}/get-founders`,
          method: "post",
          data: { search: searchTerm },
        };
      },
    }),
  }),
});

export const { useSearchFoundersQuery } = founderApi;
